import { Facebook, Instagram } from 'lucide-react'
import logoUrl from '../assets/logo-super-fut-kids-0b6c9.png'

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8 border-b border-slate-800 pb-8">
          <div className="space-y-4">
            <div className="flex items-center">
              <img
                src={logoUrl}
                alt="SuperFut Kids"
                className="h-16 w-auto bg-white rounded-xl p-2"
              />
            </div>
            <p className="text-sm text-slate-400 max-w-xs pt-2">
              Superfut — aulas personalizadas de futebol para crianças (18 meses
              - 7 anos) em São Paulo.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-white font-bold">Navegação</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#benefits" className="hover:text-super-green">
                  Benefícios
                </a>
              </li>
              <li>
                <a href="#modalities" className="hover:text-super-green">
                  Modalidades
                </a>
              </li>
              <li>
                <a href="#map" className="hover:text-super-green">
                  Área de Atendimento
                </a>
              </li>
              <li>
                <a href="/blog" className="hover:text-super-green">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-white font-bold">Redes Sociais</h4>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/superfut.kids/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-super-green hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100093504167795"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-super-blue hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
          <p>
            &copy; {new Date().getFullYear()} SuperFut Kids. Todos os direitos
            reservados.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="#" className="hover:text-white">
              Privacidade
            </a>
            <a href="#" className="hover:text-white">
              Termos de Uso
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
